const AccessDenied = () => (
  <div>
    <h1>Authorization error</h1>
    <p>You don&apos;t have access to this page.</p>
  </div>
);

export default AccessDenied;
